import { authApiService } from '@/api/authApiService';
import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import { VaultAccountDetailsType, VaultHolderType, VaultRegionType } from '@/types/myVaultTypes';

export type CreateVaultAccountPayloadType = {
  region: VaultRegionType;
  bank_name: string;
  bank_is_other: boolean;
  nickname: string;
  holder_type: VaultHolderType;
  rails: string[];
  fields: Record<string, string>;
};

export const createVaultAccountApi = (
  data: CreateVaultAccountPayloadType,
  options: RequestOptions
): Promise<ApiResponseType<VaultAccountDetailsType>> => {
  return authApiService.POST('/my-vault/accounts/create/', data, null, options);
};
